import { NavLink } from "react-router-dom";
import { RiAdminFill } from "react-icons/ri";
import { FaDatabase, FaUserTie } from "react-icons/fa";
import { TbLogout2 } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import "../commoncss/Sidebar.css";
import { MdMeetingRoom, MdSupportAgent } from "react-icons/md";
import { FaUser } from "react-icons/fa";

const AgentSidebar = () => {
  const navigate = useNavigate();
  const cookie = new Cookies();

  return (
    <>
      <div className="sideBar">
        <div className="sidebar_header">
          <div className="sidebar_graphic sidebar_graphic_agent">
            <div className="graphic_orb orb_1"></div>
            <div className="graphic_orb orb_2"></div>
            <div className="graphic_orb orb_3"></div>
            <div className="graphic_icon">
              <MdSupportAgent />
            </div>
          </div>
        </div>
        <p>Agent Panel</p>
        <p>({cookie.get("username")})</p>
        {/* <li>
          <NavLink to="dashboard">
            <RiAdminFill className="nav_icon" />
            <span>Dashboard</span>
          </NavLink>
        </li> */}
        <li>
          <NavLink to="data">
            <FaDatabase className="nav_icon" />
            <span>Data</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="detailed">
            <FaDatabase className="nav_icon" />
            <span>Trail</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="rooms">
            <MdMeetingRoom className="nav_icon" />
            <span>Rooms</span>
          </NavLink>
        </li>
        {/* <li>
                    <NavLink to="profile">
                        <FaUser className="nav_icon" />
                        <span>Profile</span>
                    </NavLink>
                </li> */}
        <li>
          <NavLink
            to="agent"
            onClick={(e) => {
              e.preventDefault();
              cookie.remove("agent");
              navigate("/agent");
            }}
          >
            <TbLogout2 className="nav_icon" />
            <span>Log Out</span>
          </NavLink>
        </li>
      </div>
    </>
  );
};

export default AgentSidebar;
